<template>
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary font-weight-bold text-white">
      Generate Annual Invoice
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <div class="card-body">
      <div class="card border-0 shadow p-2 col-12">
        <div class="card-header bg-white text-muted h4">Pilih Anggota</div>
        <div class="card-body">
          <CDataTable 
            class="w-100" 
            :items="dataAnggota" 
            :fields="fields" 
            hover 
            table-filter
            :table-fitler='{label : "Search"}'
            sorter
            :items-per-page="10"              
            :items-per-page-select='{ label : "Data Per Halaman"}' 
             pagination
          >
            <template #no="{index}">
              <td class="py-2">
                {{ indexed == 0 ? index + 1 : index + indexed + 1 }}
                </td>
            </template>
            <template #no_anggota-header>
              <input type="checkbox" name id="pilihSemua"  @click="selectAll" v-model="allSelected"/> No. Anggota 
            </template>
            <template #no_anggota="{item, index}">
              <td class="py-2">
               <input type="checkbox" @click="select($event,index)" :value="item.id_user" :checked="dataUser[index].checked"  /> {{ item.no_anggota }}
              </td>
            </template>
          </CDataTable>

           
        </div>
      </div>
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
      <Button
        @click="generate()"
        class="btn btn-md btn-info px-4 py-2"
        type="submit"
        color="info"
      >Generate</Button>
    </div>
  </div>
</template>
<script>

const fields = [
  {
    key: "no",
    sorter: false,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No. Anggota",
    sorter: false,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: false
  },
  {
    key: "email",
    sorter: true,
    filter: false
  },  
  {
    key: "no_telephone",
    sorter: true,
    filter: false
  },  
  
];
import DataAnggotaService from "../../services/keanggotaan/data-anggota.service";
import IuranAnggotaService from "../../services/keanggotaan/iuran-anggota.service";
import PengaturanService from '../../services/datamaster/pengaturan.service'

import KategoriAnggotaService from "../../services/keanggotaan/kategori-anggota.service";
export default {
  data() {
    return {
      indexed : 0,
      fields,
      namaKategori: [],      
      dataKategori : [],
      formData: {
        namaKategori: "",
      },
      form : {
        users: [],
        id_pengaturan_iuran : ''
      },
      dataUser : [],
      dataTahun : [],
      dataAnggota : [],
      tahun: '',
      nominal: 0,
      selected: [],
      allCheckSelected : false,
      allSelected: false
    };
  },

  mounted() {
    for (let index = 0; index < 30; index++) {
      this.dataTahun.push({
        tahun : 2020+index
      })
      
    }
    this.getDetailPengaturan()
    this.getKategori("0", "500", "default");

  },

  methods: {
    getDetailPengaturan() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PengaturanService.getDetail(this.$route.params.id_pengaturan_iuran)
      .then(response => {
        this.nominal = response.data.singleData.nominalIuran
        this.form.id_pengaturan_iuran = response.data.singleData.idPengaturanIuran
        loader.hide()
        this.getDataAnggota('default',response.data.singleData.idKategoriAnggota)
      })
    },
    selectAll: function() {
        if(this.allSelected) {
          this.allCheckSelected = false;
        } else {
          this.allCheckSelected = true;
        }


        if (!this.allSelected) {
          for (let index = 0; index < this.dataAnggota.length; index++) {

              this.dataUser[index].id_user = this.dataAnggota[index].id_user
              this.dataUser[index].checked = true
          }
        } else {
          for (let index = 0; index < this.dataAnggota.length; index++) {

              this.dataUser[index].id_user = null
              this.dataUser[index].checked = false
          }
        }
          
    },
    select: function(e, index) {
        if(!e.target.checked) {
          this.allSelected = false
          this.dataUser[index].id_user = null
          this.dataUser[index].checked = false 
        } else {
          var data = e.target.value;
          this.dataUser[index].id_user = data 
          this.dataUser[index].checked = true 
        }
    },
    nominalIuran(value) {
      this.nominal = value;
    },
    getDataAnggota(tahun,kategori) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this
      
      DataAnggotaService.getDataAnggotaPeriodeTahunKategori(tahun, kategori)
        .then(response => {
          this.dataAnggota = response.data.data;
          for (let index = 0; index < this.dataAnggota.length; index++) {
            this.dataUser.push(
              {
                id_user : null,
                checked : false,
              }
            );
          }

          loader.hide()
        }).catch(error => {
          loader.hide()

      })
    },
    getData(tahun, kategori){
      DataAnggotaService.getDataAnggotaPeriodeTahunKategori(tahun, kategori)
      .then(response => {
        this.dataAnggota = response.data.data;
      }).catch(error => {
      })
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    generate() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin akan melakukan generate invoice ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            this.form.users = this.dataUser;
            IuranAnggotaService.generateAnnualInvoice(this.form)
            .then(response => {
              this.alertSuccess();
            }).catch(error => {
              // comment console console.log(error);
            })
            this.$router.push({ path: "/keanggotaan/laporan-iuran" });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getKategori(currentPage, pageSize, filter) {
      KategoriAnggotaService.getKategoriAnggota(currentPage, pageSize, filter)
        .then(response => {
          this.dataKategori = response.data.data.content; 
        })
        .catch(error => {
          // comment console console.log(error);
        });
    }
  }
};
</script>